import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Link, NavLink, Redirect, Switch} from 'react-router-dom';
import Route from 'react-router-dom/Route';
import ReactPlayer from 'react-player';
import 'bootstrap/dist/css/bootstrap.min.css'


function App() {
  return (
    <Router>

        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/Nychos-la-art-show" component={postid_1} />
          <Route path="/la-art-show-2022" component={postid_4} />
          <Route path="/persue-x-frens-house" component={postid_5} />
          <Route path="/frens-house-squiggledao-eth-denver" component={postid_2 } />
          <Route path="/nychos-x-persue-dissection-of-bunny-kitty" component={postid_3} />
          <Route component={Home} />
        </Switch>
    </Router>
  );
}
class Home extends React.Component {
  render() {
    return (
      <div className="container pt-3">
        <div className="row">
          <Link to="/Nychos-la-art-show">
            <article className="best-post">
              <div
                className="best-post-image"
                style={{
                  backgroundImage: `url("https://imagedelivery.net/vsd_Iz6gESJTcupddfgvyQ/ea883a7b-bb70-40c3-0998-e33e66ee6a00/public")`
                }}
              ></div>
              <div className="best-post-content">
                <div className="best-post-content-cat">Editorial</div>
                <div className="best-post-content-title">
                  Nychos Has Been Meditating On The Dissection Of Himself
                </div>
                <div className="best-post-content-sub">
                  In preparation for his first solo gallery show in Los Angeles,
                  we meditate with Nychos on the psychedelic, experimental and
                  metaphysical aspects of his body of work both past and
                  present. As excitement builds around The Awakening, Nychos is
                  confident more will understand its purpose.
                </div>
              </div>
            </article> 
            </Link>

            <div class="post-card-wrap">
          <Link to="/frens-house-squiggledao-eth-denver">
            <article className="post__card-2">
              <div className="post__card_-2">
                <div
                  className="post__card__image-2"
                  style={{
                    backgroundImage: `url("https://imagedelivery.net/vsd_Iz6gESJTcupddfgvyQ/347efd75-64aa-4f93-a9af-c8b5e5a7b400/public")`
                  }}
                ></div>
                <div>
                  <div className="post__card_meta-2">
                    <div className="post__card_cat">youtube</div>
                    <p className="post__card_title-2">frens.House X SquiggleDAO</p>
                    <p className="post__card_alttitle-2">
                      Aerosal art merges with generative art IRL at ETH.Denver
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </Link>
          <Link to="/nychos-x-persue-dissection-of-bunny-kitty">
            <article className="post__card-2">
              <div className="post__card_-2">
                <div
                  className="post__card__image-2"
                  style={{
                    backgroundImage: `url("https://imagedelivery.net/vsd_Iz6gESJTcupddfgvyQ/8769d007-7db5-4e0e-19a0-010266cfa300/public")`
                  }}
                ></div>
                <div>
                  <div className="post__card_meta-2">
                    <div className="post__card_cat">youtube</div>
                    <p className="post__card_title-2">
                      A conversation with NYCHOS + PERSUE1
                    </p>
                    <p className="post__card_alttitle-2">
                      Awakening to the Power Of NFTs
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </Link>
          <Link to="la-art-show-2022">
            <article className="post__card-2">
              <div className="post__card_-2">
                <div
                  className="post__card__image-2"
                  style={{
                    backgroundImage: `url("https://imagedelivery.net/vsd_Iz6gESJTcupddfgvyQ/d474767d-b546-4a1a-1fcb-30861fd1e500/public")`
                  }}
                ></div>
                <div>
                  <div className="post__card_meta-2">
                    <div className="post__card_cat">youtube</div>
                    <p className="post__card_title-2">LA Art Show 2022</p>
                    <p className="post__card_alttitle-2">
                      A Look Inside The Fabrik Media + B.Creative + frens.House
                      NFT Salon
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </Link>
          <Link to="/persue-x-frens-house">
            <article className="post__card-2">
              <div className="post__card_-2">
                <div
                  className="post__card__image-2"
                  style={{
                    backgroundImage: `url("https://imagedelivery.net/vsd_Iz6gESJTcupddfgvyQ/8050ab01-680a-4ad3-7197-9730f3f43200/public")`
                  }}
                ></div>
                <div>
                  <div className="post__card_meta-2">
                    <div className="post__card_cat">youtube</div>
                    <p className="post__card_title-2">Persue1 x frensHouse</p>
                    <p className="post__card_alttitle-2">
                      How Web3, and NFTs Are Shaping Contemporary Art
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </Link>
          
          </div>
     </div>
      
        
       </div>   
    );
  }
}

class postid_1 extends React.Component {
  render() {
    return (
      <div className="header">
        <Link to="/" class="back">
          Back
        </Link>
        <div class="main container">
          <h5>frens.House Media</h5>
          <h1>Nychos Has Been Meditating On The Dissection Of Himself </h1>
          <h7>Author</h7>
          <a href="https://twitter.com/thatsthatfuego" class="authorlink">
            Evan J. Lancaster
          </a>
          <figure>
            <img src="https://imagedelivery.net/vsd_Iz6gESJTcupddfgvyQ/ea883a7b-bb70-40c3-0998-e33e66ee6a00/public" />
          </figure>
          <div class ="photo-credit"> 
          <h7><i>Photo Credit: Quinn Stirdivant </i></h7>
          
          </div>

          <div class="pl-0 col-md-12 pt-2">
            <div class="editorial-text">
            <p>Nychos has been meditating.</p>
            <p>
              This is an important, and often practiced activity in his
              paint-splattered studio where the Austrian-born artist has spent
              the last few years subconsciously preparing for his first Los
              Angeles show, <i>The Awakening.</i>
            </p>
            <p>
              On an overcast January day, Nychos spoke with frens.House to share
              more details behind the concept of<i>The Awakening.</i>, which
              features immersive installations, collaborations with Yanoe, and
              Pursue1, as well as a set of NFT tickets.
            </p>

            <p>
              For Nychos, meditation has helped translate the experiences and
              traumas of his past lives, which manifest themselves physically
              and metaphysically, into visual representations.
            </p>
            <p>
              “[<i>The Awakening.</i>] is literally the story of my own
              self-healing, changing from this art warrior I used to be, the
              person with his own anger constantly dissects himself – doesn’t
              matter if it’s fucking Mickey Mouse,” Nychos explained to
              frens.House. “Being an artist, and painting, or doing anything
              directly from the soul is an act of self healing, because in this
              incarnation we are ready to do so.”
            </p>
            <p>
              Through this process, we see that mediation is a key to the
              inspiration which led to <i>The Awakening.</i>, not just in terms
              of his first solo show opening at Mirus Gallery on February 22,
              but to what Nychos attributes to mankind’s collective realization
              of consciousness, life and death as a whole.
            </p>
            <p>
              While the concept may seem foreign, it’s happening. As blockchain
              technology continues to push the boundaries of what is possible on
              a peer to peer level, Web3 protocols are undoubtedly shaking
              artists and collectors out of the corporate gallery scene
              dreamstate and allowing smart contracts and NFTs to play a role in
              monetization like never before.
            </p>
            <p>
              “I mean, yeah, it’s great – I get some fucking money. People like
              to talk about it, and enjoy the art on Instagram, and on the
              internet and in museums – but who supports it,” Nychos asked
              non-rhetorically. “Now, with the NFT there are people who suddenly
              collect and support.”
            </p>
            <p>
              We linked up with Pursue1 at Nychos’ Los Angeles studio to watch
              the duo finish the <i>"Dissection of BunnyKitty,”</i> chat about Web3,
              and discover how Nychos will be incorporating NFTs into the
              capacity of <i>The Awakening.</i>
            </p>
            <p>
            But first, it was time to meditate. 
            </p>
            <p>
             *****
            </p>
            <p>
            Existing in alternative realities both as a legendary graffiti artist and muralist, Nychos also displays extreme discipline as a prolific canvas painter. This juxtaposition, in addition to his recognizable dissection 
            motif, has garnered him world-wide recognition. Nychos continues to bring his visions into new dimensions through the incorporation of translucence, X-ray and skeletal renderings on the anatomy of any shape or character he can imagine. 
            </p>
            <p>
              We linked up with Pursue1 at Nychos’ Los Angeles studio to watch
              the duo finish the “Dissection of BunnyKitty,” chat about Web3,
              and discover how Nychos will be incorporating NFTs into the
              capacity of <i>The Awakening.</i> 
            </p>
            <p>
            While his body of work involving the dissection of pop culture icons, and other characters has easily become his most-identifiable work, Nychos admits that the inspiration for his signature style was developed through the endurance of an internal war. 
            </p>
            <p>
            Explaining that his passion for cartoon animation remains a core influence in his work, he cites the “looniness” of <i>Nickelodeon's Ren & Stimpy</i> as being a direct inspiration. However, within his most recognized work involving anatomic dissection, Nychos said he came to a realization that he was painting the traumas of his past lives – and deaths.  
            </p>
            <p>
            “What the artist does, the visions that he or she has is literally bound to the traumatic situation. In my mind, ‘that’s sick, I want to cut his body up – break it up, pull the guts out,’ this is all stuff which happened to me, or that I did to other people so many times. It’s always a reflection of myself,” he said. “Especially with the dissection work and the anatomy work – in the end I just dissected myself.”  

            </p>
            <p>
            Still, Nychos insists that what the audience views on a wall or canvas is just a fragment of the visions he experiences.  

            </p>
            <p>
            Today, Nychos said he has found a new tool to bring the colossal scope of his visions to fruition in an entirely new dimension. 
            </p>
            <p>
            The tool? NFT technology. 
            </p>
            <p>
            “Before I got really into graffiti, I always wanted to do animation,” he said. “The transition now is kind of awesome — like when this NFT thing came up, I realized this was the point — because the visions I have are moving pictures — I am literally just painting a frame.” 
            </p>
            <p>
            Now available on Opensea, Nychos is currently working with a 3-D rendering artist on the NFT project for  <i>The Awakening.</i> The NFT, is a 3-D animated video clip of a breakdancing rabbit. At one point the rabbit splits in half, revealing symmetrical layers of rabbit and human anatomy, then returns to its original form.
            </p>
            <p>
            Recognized as <i>Frank</i> from <i>Donnie Darko</i>, the rabbit character is well-known imagery Nychos says pays homage to his work within the Rabbit Eye Movement circa 2011.  
            </p>
            <p>
            The series also doubles as tickets to the show. 
            </p>
            <p>
            “We started to do the first designs together in 2012, we did our first work together with the tyrannosaurus — it just fucking blew my mind. And that was just a VR thing,” he said. “Suddenly the NFT thing came up, and the cool thing is I can show what’s possible.”
            </p>
            <p>
            Scoffing at the idea of working for a traditional animation studio, he has no real desire to become a traditional animator. But is nonetheless intrigued by the concept of NFTs because the technology can allow him to create moving pictures.
            </p>
            <p>
            “How does someone like me suddenly get into cartoon work? I’m not going to start working for Disney — fuck no, I’m not going to start working for Nickelodeo. Any kind of animation work actually fucking sucks — but I have the visions, and I have the ideas,” he said. “I have a really good friend that is a fucking legend in 3-D rendering he undertands my ideas and process. I have the art director, but he is making it move.” 
            </p>
            <h7>
            <b><i>The Awakening is open at Mirus Gallery in Los Angeles from Tuesday, Feb. 22 - May 1. </i></b>
            </h7>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

class postid_2 extends React.Component {
  render() {
    return (
      <div className="header">
        <Link to="/" class="back">
          Back
        </Link>
        <div class="main container">
          <h5>frens.House Media</h5>
          <h1>frens.House x SquiggleDAO</h1>
          <a href="#" class="authorlink">
            frensHouse Media
          </a>
          <div class="pl-0 col-md-12 pt-2">
          <ReactPlayer style={{
            marginLeft: '25%'}}
            url='https://youtu.be/5mSdJo5jbOo' />
            <h3>
              Tag along with the frens.house and Wet Paint crew on teir recent trip to Denver, Colorado to attend ETH.Denver.
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

class postid_3 extends React.Component {
  render() {
    return (
      <div className="header">
        <Link to="/" class="back">
          Back
        </Link>
        <div class="main container">
          <h5>frens.House Media</h5>
          <h1>A Conversation with Nychos X Persue1</h1>
          <a href="#" class="authorlink">
            frensHouse Media
          </a>
          <div class="pl-0 col-md-12 pt-2">
          <ReactPlayer style={{
            marginLeft: '25%'}}
            url='https://youtu.be/UPVEdWPSXU4' />
            <h3>
              Get a quick behind the scenes view of two master artists as they discuss the interworkings of the upcoming Nychos "Awakening" Show.
            </h3>
          </div>
        </div>
      </div>
    );
  }
}
class postid_4 extends React.Component {
  render() {
    return (
      <div className="header">
        <Link to="/" class="back">
          Back
        </Link>
        <div class="main container">
          <h5>frens.House Media</h5>
          <h1>LA Art Show 2022: A Look Inside The Fabrik Media + B. Creative + frens.House NFT Salon</h1>
          <a href="#" class="authorlink">
            frensHouse Media
          </a>
          <div class="pl-0 col-md-12 pt-2">
          <ReactPlayer style={{
            marginLeft: '25%'}}
            url='https://youtu.be/RMiAKo95hnM' />
            <h3>
            Join frens.House as we tour the 2022 Los Angeles Art Show. This year frens.House collaborated with our frens at Fabrik Media and B. Creative Studios to showcase more than 60 emerging NFT artists. To do so, frens.House helped executive the conceptual design, build out and curation inside the Fabrik Media + B. Creative + frens.House NFT Salon which was recently featured inside the 2022 L.A. Art Show.
            </h3>
          </div>
        </div>
      </div>
    );
  }
}
class postid_5 extends React.Component {
  render() {
    return (
      <div className="header">
        <Link to="/" class="back">
          Back
        </Link>
        <div class="main container">
          <h5>frens.House Media</h5>
          <h1> Persue1 x frensMedia: How Web3 and NFTs are Shaping Contemporary Art</h1>
          <a href="#" class="authorlink">
            frensHouse Media
          </a>
          <div class="pl-0 col-md-12 pt-2">
          <ReactPlayer style={{
            marginLeft: '25%'}}
            url='https://youtu.be/gzzj1IAAYgc' />
            <h3>
           
            Tag along with frensMedia on a recent trip to San Diego, Calif., to visit frensHouse artist Persue1. During our studio visit, Persue shared his perspective on the unique opportunities developing for artists within the Web3 space, including himself. He also spoke about his evolution as both a digital artist and graffiti writer entering new territory within the metaverse, and touched on what has intrigued him during his journey, thus far.
            </h3>
          </div>
        </div>
      </div>
    );
  }
}
class Header extends React.Component {
  render() {
    //header
    return
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js